import { persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

export type SurveyModalStore = {
  isOpen: boolean;
  lastSubmitted: number | null;
  sessionClosed: boolean;
  openModal: () => void;
  closeModal: () => void;
  submitSurvey: () => void;
};

export const useSurveyModalStore = create(
  persist<SurveyModalStore>(
    (set) => ({
      isOpen: false,
      lastSubmitted: null,
      sessionClosed:
        typeof window !== 'undefined' && window.sessionStorage
          ? sessionStorage.getItem('survey-modal-closed') === 'true'
          : false,

      openModal: () => {
        set((state) => {
          // Don't open if submitted within last week
          if (state.lastSubmitted) {
            const oneWeek = 7 * 24 * 60 * 60 * 1000; // one week in milliseconds
            const now = Date.now();
            if (now - state.lastSubmitted < oneWeek) {
              return state;
            }
          }

          // Don't open if closed in current session
          if (state.sessionClosed) {
            return state;
          }

          return { ...state, isOpen: true };
        });
      },

      closeModal: () => {
        set((state) => ({
          ...state,
          isOpen: false,
          sessionClosed: true, // Track that it was closed in this session
        }));
        sessionStorage.setItem('survey-modal-closed', 'true');
      },

      submitSurvey: () => {
        set((state) => ({
          ...state,
          isOpen: false,
          lastSubmitted: Date.now(),
          sessionClosed: true,
        }));
      },
    }),
    {
      name: 'survey-modal-store',
      partialize: (state) =>
        ({
          lastSubmitted: state.lastSubmitted,
        }) as SurveyModalStore,
    },
  ),
);
